














































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IDelegate } from "@/interfaces";
import LinkAddress from "./LinkAddress.vue";

@Component({
  components: {
    LinkAddress,
  },
  computed: {
    ...mapGetters("delegates", ["delegates"]),
  },
})
export default class LinkWallet extends Vue {
  @Prop({ required: false, default: "" }) public address: string;
  @Prop({ required: false, default: null }) public asset: { [key: string]: [any] } | null;
  @Prop({ required: false, default: "" }) public publicKey: string;
  @Prop({ required: false, default: 0 }) public type: number;
  @Prop({ required: false, default: 1 }) public typeGroup: number;
  @Prop({ required: false, default: true }) public trunc: boolean;
  @Prop({ required: false, default: "top" }) public tooltipPlacement: string;
  @Prop({ required: false, default: false }) public showTimelockIcon: boolean;
  @Prop({ required: false, default: false }) public showAsType: boolean;

  public addressResolved: string | undefined;

  private delegates: IDelegate[];

  public async mounted() {
    this.addressResolved = await this.address;
  }

  public data() {
    return {
      addressResolved: undefined,
    };
  }

  get getVoteColor(): string {
    return this.isUnvote ? "text-red" : "text-green";
  }

  get isUnvote(): boolean {
    if (this.asset && this.asset.votes) {
      const vote = this.asset.votes[0];
      return vote.charAt(0) === "-";
    }
    return false;
  }

  get votePublicKey(): string {
    if (this.asset && this.asset.votes) {
      const vote = this.asset.votes[0];
      return vote.substr(1);
    }
    return "";
  }

  get votedDelegate(): IDelegate | null {
    return this.votePublicKey ? this.delegates.find((d) => d.publicKey === this.votePublicKey) : null;
  }

  get votedDelegateAddress(): string {
    return this.votedDelegate ? this.votedDelegate.address : "";
  }

  get votedDelegateUsername(): string {
    return this.votedDelegate ? this.votedDelegate.username : "";
  }

  get multiPaymentRecipientsCount(): number {
    if (this.asset && this.asset.payments) {
      return this.asset.payments.length;
    }
    return 0;
  }
}
